module.exports = __webpack_public_path__ + "img/science_screenshot_2.518f795a.jpg";